import React, { useState, useEffect } from 'react';
import Chart from "react-apexcharts";
import { ApexOptions } from 'apexcharts';

interface ChildProps {
    jobs: any;
}

const IndividualJob: React.FC<ChildProps> = ({ jobs }) => {
    const getSparklineOption :any= (job) => {
        const color =
            job.status === "failed"
                ? "#ef4444"
                : job.status === "paused"
                    ? "#f59e0b"
                    : job.status === "running"
                        ? "#3c83f6"
                        : "#14b8a6";

        return {
            series: [
                {
                    name: "Throughput",
                    data: job.throughputData.map((d) => d.value),
                },
            ],
            chart: {
                type: "area",
                height: 80,
                sparkline: { enabled: true },
                toolbar: { show: false },
                zoom: { enabled: false },
                animations: { enabled: false },
            },
            stroke: { curve: "smooth", width: 2 },
            fill: {
                type: "gradient",
                gradient: {
                    opacityFrom: 0.35,
                    opacityTo: 0,
                    stops: [0, 100],
                },
            },
            colors: [color],
            tooltip: { enabled: false },
            xaxis: { labels: { show: false } },
            yaxis: { show: false },
        };
    };
    return (
        <div className="px-0">
            <div className="my-3 d-flex flex-wrap mx-0 job-card">
      {jobs.map((item, i) => {
        const spark = getSparklineOption(item);

        return (
          <div
            key={item.id}
            className={`col-md-4 mb-3 ${item.status?.toLowerCase?.()}`}
          >
            <div
              className={`bg-white p-3 border shadow-sm rounded-12 ${
                (i + 1) % 3 !== 0 ? "me-3" : ""
              }`}
            >
              {/* HEADER */}
              <div className="d-flex">
                <div className="col my-auto d-flex">
                  <div className="col-auto icon-container d-flex align-items-center justify-content-center me-2 rounded">
                    <i className="icmn-terminal"></i>
                  </div>
                  <div>
                    <h6 className="mb-0 fw-500">{item.name}</h6>
                    <p className="text-muted mb-0 fs-13">
                      Last run: {item.lastRun}
                    </p>
                  </div>
                </div>

                <div className="col-auto ms-auto my-auto status-col d-flex align-items-center border rounded-12 fs-13 px-2 text-capitalize">
                  <i
                    className={`pe-2 ${
                      item.status?.toLowerCase() === "running"
                        ? "icmn-play3"
                        : item.status?.toLowerCase() === "completed"
                        ? "icmn-Approved-Referral"
                        : item.status?.toLowerCase() === "failed"
                        ? "icmn-Rejected-Request"
                        : "icmn-pause2"
                    }`}
                  ></i>
                  {item.status}
                </div>
              </div>

              {/* SPARKLINE */}
              <div className="my-3 sparkline-wrap">
                <Chart
                  series={spark.series}
                  options={{
                    chart: spark.chart,
                    stroke: spark.stroke,
                    fill: spark.fill,
                    colors: spark.colors,
                    tooltip: spark.tooltip,
                    xaxis: spark.xaxis,
                    yaxis: spark.yaxis,
                  }}
                  type="area"
                  height={80}
                />
              </div>

              {/* STATS */}
              <div className="my-3 d-flex mx-0 flex-wrap">
                <div className="col bg-light me-3 p-2 rounded text-center">
                  <p className="fs-13 text-muted mb-0">Avg Duration</p>
                  <p className="mb-0 fs-14">{item.avgDuration}</p>
                </div>

                <div className="col bg-light ms-3 p-2 rounded text-center">
                  <p className="fs-13 text-muted mb-0">Success Rate</p>
                  <p className="mb-0 fs-14">{item.successRate}%</p>
                </div>
              </div>

              {/* RECENT RUNS */}
              <p className="text-muted fs-13 mb-0">RECENT RUNS</p>

              <div className="d-flex mx-0 my-3 pb-3 border-bottom flex-wrap">
                {item.runs.map((itm) => (
                  <div
                    key={itm.id}
                    className={`col rounded me-2 pointer ${
                      itm.status?.toLowerCase() === "completed"
                        ? "bg-lightgreensuccess p-2"
                        : "bg-lightdanger p-2"
                    }`}
                    title={`${itm.startTime} - ${itm.duration} - ${itm.status}`}
                  />
                ))}
              </div>

              {/* FOOTER */}
              <div className="d-flex justify-content-between mt-2">
                <small className="text-muted">
                  {item.runs.length} runs in 24h
                </small>

                <small
                  className="text-primary fw-600"
                  style={{ cursor: "pointer" }}
                >
                  View Details ›
                </small>
              </div>
            </div>
          </div>
        );
      })}
    </div>
        </div>
    )
}

export default IndividualJob;